"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFieldSkeleton = void 0;

var _styles = require("@mui/styles");

var _material = require("@mui/material");

var StyledFieldSkeleton = (0, _styles.withStyles)(function () {
  return (0, _styles.createStyles)({
    root: {
      borderRadius: 5
    }
  });
})(_material.Skeleton);
exports.StyledFieldSkeleton = StyledFieldSkeleton;